import React from "react";
import useScrollToHash from "../../../components/hooks/useScrollToHash"
import ReadMore from "../../../components/common/read-more";
const StudentInformationSystemReadmore = () => {

  useScrollToHash(50)

  const styles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0px 20px",
      fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      color: "#2d3436",
      lineHeight: "1.7",
      backgroundColor: "#fff",
    },

    heroSection: {
      textAlign: "center",
      padding: "0px 20px",
    //   background: "linear-gradient(135deg, #f1f2f6 0%, #ffffff 100%)",
      borderRadius: "30px",
      // marginBottom: "60px",
    },
    sectionCard: {
      background: '#ffffff',
      borderRadius: '20px',
      padding: "25px 30px 0px 30px",
      marginBottom: '40px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
      border: '1px solid #f1f2f6',
    },
    h1: {
      
          padding: "0px 47px",
    borderRadius: "13px",
    fontSize: "31px",
    fontWeight: "700",
    background: "linear-gradient(135deg, rgb(223, 10, 10), rgb(227, 111, 132))",
    color: "rgb(255, 255, 255)",
    marginBottom: "20px",
    boxShadow: "rgba(90, 92, 255, 0.35) 0px 16px 35px;",
    },

    h2: {
      fontSize: "1.8rem",
      color: "rgb(9, 132, 227)",
      // marginTop: "60px",
      marginBottom: "25px",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: "1px",
      borderBottom: "3px solid #DF0A0A",
      display: "inline-block",
      paddingBottom: "5px",
      lineHeight: "36px"
    },

    p: {
      fontSize: "1.2rem",
      lineHeight: "1.8",
      color: "#485e64",
      marginBottom: "20px",
    },
    li: {
      // background: "#b8dbd9",
      padding: '20px',
      borderRadius: '12px',
      borderBottom: '3px solid #0984e3',
      fontSize: "1rem"
    },
    imageCard: {
      width: "100%",
      borderRadius: "20px",
      overflow: "hidden",
      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
      marginBottom: "40px",
    },

    img: {
      width: "100%",
      display: "block",
      objectFit: "cover",
    },

    bentoGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
      margin: "40px 0",
    },

    featureCard: {
      padding: "30px",
      borderRadius: "20px",
      background: "#ffffff",
      border: "1px solid #f1f2f6",
      boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
      transition: "transform 0.3s ease",
    },

    cardTitle: {
      color: "#0984e3",
      fontSize: "1.25rem",
      fontWeight: "700",
      marginBottom: "15px",
      display: "block",
    },

    splitSection: {
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      margin: "40px 0",
    },

    splitBox: (bgColor) => ({
      flex: "1",
      minWidth: "320px",
      padding: "40px",
      borderRadius: "24px",
      backgroundColor: bgColor,
    }),

    impactBanner: (bgcolor) => ({
      background: bgcolor, 
      padding: "30px 30px",
      borderRadius: "30px",
      textAlign: "center",
      margin: "15px 0",
    }),

    integrationRibbon: {
      background: "#f8f9fa",
      padding: "20px",
      borderRadius: "15px",
      textAlign: "center",
      marginBottom: "40px",
      border: "1px dashed #6c5ce7",
    },

    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "25px",
      marginTop: "40px",
    },

    benefitCard: {
      padding: "30px",
      borderRadius: "20px",
      background: "#e7e6f7",
      border: "1px solid #f1f2f6",
      boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
      transition: "all 0.3s ease",
    },

    statHighlight: {
      display: "inline-block",
      padding: "5px 15px",
      background: "#e8e6ff",
      color: "#6c5ce7",
      borderRadius: "50px",
      fontWeight: "700",
      fontSize: "1rem",
      marginBottom: "10px",
    },

    adaptationWrapper: {
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      margin: "30px",
    },

    adaptationBox: (color) => ({
      flex: "1",
      minWidth: "320px",
      padding: "35px",
      borderRadius: "20px",
      border: `1px solid ${color}33`,
      backgroundColor: `${color}14`,
    }),

    finalCTA: {
      textAlign: "center",
      padding: "30px 30px",
      background: "#e1f5fe",
      borderRadius: "30px",
      margin: "20px",
    },

    wrapper: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0px 20px",
      fontFamily: '"Inter", "IBM Plex Sans", sans-serif',
      color: "#1e272e",
      backgroundColor: "#ffffff",
    },

    commandHeader: {
      backgroundColor: "#e9ecef",
      borderRadius: "24px",
      padding: "60px 40px",
      color: "#ffffff",
      marginBottom: "50px",
      boxShadow: "0 15px 35px rgba(0,0,0,0.15)",
    },

    imageContainer: {
      borderRadius: "20px",
      overflow: "hidden",
      marginBottom: "35px",
      border: "1px solid #dfe6e9",
    },

    tileGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "20px",
      margin: "40px 0",
    },

    adminTile: {
      padding: "25px",
      // backgroundColor: "#fbc3bc",
      borderRadius: "15px",
      borderLeft: "5px solid #DF0A0A",
      transition: "transform 0.2s ease",
      fontSize: "16px"
    },

    roiBadge: {
      backgroundColor: "#DF0A0A",
      color: "#fff",
      padding: "4px 12px",
      borderRadius: "6px",
      fontWeight: "bold",
      fontSize: "1rem",
      marginRight: "10px",
      textWrap: "no-wrap"
    },

    comparisonGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: "25px",
      marginTop: "40px",
      marginBottom: "40px",
    },
    // The card base style
    compareCard: (borderColor, accentColor) => ({
      background: `${accentColor}16`, // Adding '15' to a hex code makes it ~8% transparent
      padding: "30px",
      borderRadius: "24px",
      border: `1px solid ${accentColor}33`, // Soft border matching the theme
      borderTop: `6px solid ${borderColor}`,
      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      boxShadow: '0 10px 20px rgba(0,0,0,0.02)',
      display: 'flex',
      flexDirection: 'column',
    }),
    cardTitle: {
      fontSize: '1.4rem',
      fontWeight: '800',
      marginBottom: '15px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    p: {
      fontSize: '1.05rem',
      lineHeight: '1.7',
      color: '#4b5563',
      margin: 0
    },
    strong: (color) => ({
        color: color,
        fontSize: '1.1rem',
        display: 'block',
        marginBottom: '8px'
    }),

    footerCard: {
      textAlign: "center",
      padding: "30px",
      backgroundColor: "#e1f5fe",
      borderRadius: "30px",
      color: "white",
      margin: "20px 0",
    },
    sectionDivider: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "15px 0",
      position: "relative",
    },
    dividerLine: {
      height: "2px",
      width: "100%",
      backgroundColor: "#dfe6e9",
      position: "absolute",
    },
    dividerDot: {
      width: "40px",
      height: "6px",
      backgroundColor: "#0984e3", // Change to #DF0A0A for Admin sections
      borderRadius: "10px",
      zIndex: 1,
    },
  };

  return (
    <div className="read-more-container">
      <div className="menu-container" id="StudentInformationSystem">
        {/* --- HERO --- */}
        <div className="ps-rm-section-card">
          <div className="ps-rm-hero">
            <div className="enrollment-image-card ps-rm-image-wrapper">
              <img
                src="../images/product&soluction/read-more/sisReadmore2.jpg"
                alt="SIS Overview"
                className="ps-rm-image"
              />
            </div>
            <h1 className="ps-rm-h1">
              Comprehensive Guide to Student Information Systems (SIS) for K-12
              Schools
            </h1>
            {/* <br /> */}
            <span
              style={{
                fontSize: "1.7rem",
                fontWeight: "400",
                color: "#636e72",
              }}
            >
              (Online and Onsite | Public and Private | 2026 Edition)
            </span>
            <p className="ps-rm-text">
              Elevate Your K-12 School with Modern Student Information Systems
              (SIS) Software
            </p>
          </div>
          {/* --- INTELLIGENCE SECTION --- */}
          <ReadMore maxHeight="100px">
            <p className="ps-rm-text">
              A modern Student Information System (SIS) – sometimes called a
              Student Management System (SMS) – is the central nervous system of
              any K-12 school or district. In the dynamic world of K-12
              education, where student success hinges on efficient data
              management and seamless operations, a robust Student Information
              System (SIS) is no longer optional—it's indispensable. Whether
              you're running a public school district navigating state mandates,
              a private academy focused on personalized learning, a fully online
              program reaching global learners, or a traditional onsite campus
              managing daily logistics, SIS software transforms chaos into
              clarity. Our smart SIS securely stores, manages, and connects
              every piece of student-related data: demographics, attendance,
              grades, schedules, behavior, health, parent contact info, state
              reporting, billing, and much more.
            </p>
            <p className="ps-rm-text">
              In 2026 the best SIS platforms go far beyond a digital gradebook
              or filing cabinet. With smart AI integration on the rise, SIS
              software isn't just about storage—it's about intelligence,
              predicting trends and personalizing education. Our SIS is
              cloud-based, mobile-friendly, highly integrated, and designed to
              serve the very different needs of public districts,
              private/independent schools, charter networks, and fully
              online/virtual academies. Our SIS platforms offer modular,
              customizable tools to address the full spectrum of school needs.
              Here's a detailed overview:
            </p>
          </ReadMore>
        </div>

        {/* --- MODULES GRID --- */}
        <div className="ps-rm-bento-grid ps-rm-section-card">
          <li
            style={{ backgroundColor: "#eaf4ff" }}
            className="readmore-card-hover ps-rm-list-item"
          >
            <span className="ps-rm-card-title">
              Student Demographics & Enrollment
            </span>
            <p className="ps-rm-text">
              Centralized profiles with demographics, emergency contacts, and
              custom fields (e.g., allergies or IEPs). Seamless handoff from
              admissions software, auto-populating data for new enrollees. For
              online schools: Virtual residency verification and global
              time-zone support. Public schools: Integration with district
              lottery systems.
            </p>
          </li>

          <li
            style={{ backgroundColor: "#f3edff" }}
            className="readmore-card-hover ps-rm-list-item"
          >
            <span className="ps-rm-card-title">Attendance & Scheduling</span>
            <p className="ps-rm-text">
              Real-time tracking with mobile check-ins, automated alerts for
              absences, and truancy reports. Master schedulers with
              drag-and-drop interfaces, conflict resolution, and course request
              portals. Onsite adaptations: Bus route assignments and room
              utilization. Online: Asynchronous session logging and virtual
              class calendars.
            </p>
          </li>

          <li
            style={{ backgroundColor: "#e9fbf8" }}
            className="readmore-card-hover ps-rm-list-item"
          >
            <span className="ps-rm-card-title">Gradebook & Tracking</span>
            <p className="ps-rm-text">
              Flexible grading options: standards-based, competency, or
              traditional. Progress monitoring with dashboards for teachers,
              students, and parents. Private schools: Advanced portfolio tools
              for holistic assessments. Public: Alignment with state standards
              and testing data imports.
            </p>
          </li>

          <li
            style={{ backgroundColor: "#fae1dd" }}
            className="readmore-card-hover ps-rm-list-item"
          >
            <span className="ps-rm-card-title">Behavior & Discipline</span>
            <p className="ps-rm-text">
              Incident logging, referral workflows, and positive behavior
              intervention supports (PBIS). Analytics to spot patterns, reducing
              suspensions through proactive interventions. All types:
              Customizable codes for compliance with anti-bullying laws.
            </p>
          </li>

          <li
            style={{ backgroundColor: "#eae4e9" }}
            className="readmore-card-hover ps-rm-list-item"
          >
            <span className="ps-rm-card-title">Health & Special Ed</span>
            <p className="ps-rm-text">
              Immunization tracking, medication administration logs, and health
              visit records. IEP/504 plan creation, goal tracking, and parent
              e-signatures. Online schools: Digital health forms for remote
              families. Onsite: Integration with nurse stations.
            </p>
          </li>

          <li
            style={{ backgroundColor: "#fff6e5" }}
            className="readmore-card-hover ps-rm-list-item"
          >
            <span className="ps-rm-card-title">Reporting & Analytics</span>
            <p className="ps-rm-text">
              Custom reports for state submissions, demographics, and
              performance metrics. AI-powered insights: Predictive modeling for
              dropout risks or enrollment forecasts. Public schools: One-click
              federal reporting (e.g., CRDC). Private: Donor and alumni
              analytics.
            </p>
          </li>
        </div>

        <div className="ps-rm-comparison-grid ps-rm-section-card">
          {/* CARD 1: ONLINE SCHOOLS */}
          <div
            style={{ borderTopColor: "#6c5ce7", background: "#6c5ce716" }}
            className="comparison-card-hover readmore-card-hover ps-rm-compare-card "
          >
            <h3 className="ps-rm-card-title">
              <span className="card-icon">🌐</span> Online Schools
            </h3>
            <ReadMore maxHeight="160px">
              <p className="ps-rm-text">
                These environments demand flexibility for remote operations. Our
                SIS excel with virtual attendance (e.g., login-based tracking),
                asynchronous grading, and global analytics. Features include
                video conference logs, digital portfolios, and AI chatbots for
                student support. Public online charters handle state funding
                compliance remotely, while private virtual academies focus on
                personalized learning paths for diverse time zones.
              </p>
            </ReadMore>
          </div>

          {/* CARD 2: ONSITE SCHOOLS */}
          <div
            style={{ borderTopColor: "#00d2ff", background: "#00d2ff16" }}
            className="comparison-card-hover readmore-card-hover ps-rm-compare-card "
          >
            <h3 className="ps-rm-card-title">
              <span className="card-icon">🏫</span> Onsite Schools
            </h3>
            <ReadMore maxHeight="160px">
              <p className="ps-rm-text">
                Physical campuses require robust logistics. Platforms like
                PowerSchool or Skyward offer RFID attendance, facility
                management, and event scheduling. Public onsite districts manage
                large-scale busing and cafeteria integrations, ensuring equity
                in resource distribution. Private onsite schools emphasize
                campus security features, like visitor check-ins tied to student
                records.
              </p>
            </ReadMore>
          </div>

          {/* CARD 3: PRIVATE SCHOOLS */}
          <div
            style={{ borderTopColor: "#0984e3", background: "#0984e316" }}
            className="comparison-card-hover readmore-card-hover ps-rm-compare-card "
          >
            <h3 className="ps-rm-card-title">
              <span className="card-icon">💎</span> Private Schools
            </h3>
            <ReadMore maxHeight="160px">
              <p className="ps-rm-text">
                Prioritize selectivity and sustainability. Our SIS includes
                advanced CRM for alumni and donors, variable tuition modeling,
                and legacy admission tracking. Marketing tools highlight student
                success stories, aiding recruitment. Faith-based privates add
                religious education modules.
              </p>
            </ReadMore>
          </div>

          {/* CARD 4: PUBLIC SCHOOLS */}
          <div
            style={{ borderTopColor: "#00b894", background: "#00b89416" }}
            className="comparison-card-hover readmore-card-hover ps-rm-compare-card "
          >
            <h3 className="ps-rm-card-title">
              <span className="card-icon">🏛️</span> Public Schools
            </h3>
            <ReadMore maxHeight="160px">
              <p className="ps-rm-text">
                Emphasize equity and scale. Systems like Infinite Campus or
                Aeries automate massive reporting for districts, including ELL
                tracking and free/reduced lunch eligibility. Charter publics
                benefit from hybrid features blending public compliance with
                private-like customization. Tools ensure transparency in data
                for school boards and communities.
              </p>
            </ReadMore>
          </div>
        </div>
        {/* --- ADAPTATIONS SPLIT --- */}

        {/* --- PROVEN IMPACT --- */}
        <div className="ps-rm-section-card">
          <div style={{ background: "#e1f5fe" }} className="ps-rm-impact">
            <h2 className="ps-rm-h1">Proven Impact and Case Studies</h2>
            <p className="ps-rm-text">
              Schools adopting modern SIS report game-changing results. A
              mid-sized public district using Infinite Campus reduced reporting
              time by 50%, allowing more focus on instruction. Private academies
              see 25% higher parent engagement via mobile apps. Online programs
              like those powered by Alma report improved retention through
              predictive analytics, with one virtual academy boosting graduation
              rates by 15%.User reviews average 4.5+ stars, praising intuitive
              interfaces and responsive support. Implementation is
              user-friendly, with data migration services and training included
              in most packages.
            </p>
          </div>
          {/* --- FOOTER CTA --- */}
          <div style={{ background: "#6c5ce72b" }} className="ps-rm-impact">
            <h3 className="ps-rm-h1">Unlock Your School's Potential</h3>
            <p className="ps-rm-text">
              In an era where education is increasingly data-centric, investing
              in SIS software positions your K-12 institution for
              success—whether online or onsite, private or public. Streamline
              operations, empower educators, and engage families like never
              before. Explore top providers like Skyward or FACTS for a free
              demo, and experience the transformation. Your students deserve a
              system as innovative as they are—make the switch and watch your
              school thrive.
            </p>
          </div>
        </div>
      </div>

      <div className="ps-rm-divider">
        <div className="ps-rm-divider-line"></div>
        <div className="ps-rm-divider-dot"></div>
      </div>

      <div className="menu-container" id="Empower">
        {/* --- HERO SECTION --- */}
        <div className="ps-rm-section-card">
          <div className="enrollment-image-card ps-rm-image-wrapper">
            <img
              src="../images/product&soluction/read-more/sisReadmore4.jpg"
              alt="Academic Management"
              className="ps-rm-image"
            />
          </div>
          <h1 className="ps-rm-h1">
            Empower Your K-12 School with Cutting-Edge Academic Management
            Software
          </h1>
          <div className="readmore-card-hover-border ps-rm-integration-ribbon">
            <strong>Core Integrations:</strong> Canvas LMS • Schoology •
            Blackboard Learn • Google Classroom • Moodle
          </div>
          <ReadMore maxHeight="100px">
            <p className="ps-rm-text">
              In the ever-evolving K-12 education sector, academic management
              software stands as a pivotal tool for delivering high-quality
              instruction, tracking student progress, and fostering
              collaborative learning environments. Whether you're a public
              school district emphasizing equitable access, a private
              institution prioritizing personalized curricula, a fully online
              program adapting to remote learners, or a traditional onsite
              campus managing classroom dynamics, this software integrates
              seamlessly to enhance teaching and learning.
            </p>
            <p className="ps-rm-text">
              Our Platform integrates Canvas LMS, Schoology, Blackboard Learn,
              Google Classroom, and Moodle that empowe educators to create
              engaging content, assess performance in real-time, and provide
              data-driven insights—all while complying with standards like
              Common Core or state-specific requirements. Our K-12 academic
              management driven by smartly-enhanced personalization and hybrid
              learning demands. This detailed guide explores the features,
              benefits, and tailored applications of academic management
              software, helping schools—online or onsite, private or
              public—unlock their full potential and achieve better student
              outcomes.
            </p>
          </ReadMore>
        </div>

        {/* --- WHY ESSENTIAL SECTION --- */}

        <div className="ps-rm-section-card">
          <div className="enrollment-image-card ps-rm-image-wrapper">
            <img
              src="../images/product&soluction/read-more/sisReadmore5.jpg"
              alt="Benefits"
              className="ps-rm-image"
            />
          </div>
          <h2 className="ps-rm-h2">
            Why Academic Management Software is a Must-Have for K-12 Schools
          </h2>
          <p className="ps-rm-text">
            Academic management software, often synonymous with Learning
            Management Systems (LMS) or integrated platforms, goes beyond basic
            tools to orchestrate the entire academic ecosystem. It addresses key
            challenges like disjointed lesson delivery, inconsistent
            assessments, and limited parent involvement. For public schools
            under budget constraints, it ensures efficient resource use and
            compliance reporting. Private schools leverage it for differentiated
            instruction and premium experiences. Online programs rely on it for
            asynchronous engagement, while onsite schools use it for blended
            classroom tech.
          </p>

          <ul className="ps-rm-list">
            <li
              style={{ backgroundColor: "#e9fbf8" }}
              className="readmore-card-hover ps-rm-list-item"
            >
              <span className="ps-rm-bold-text-highlighted">
                Up to 30% Higher Retention
              </span>
              <p className="ps-rm-text">
                <strong>Improved Student Engagement:</strong> Interactive tools
                like gamification and multimedia boost participation.
              </p>
            </li>

            <li
              style={{ backgroundColor: "#f3edff" }}
              className="readmore-card-hover ps-rm-list-item"
            >
              <span className="ps-rm-bold-text-highlighted">
                25–40% Less Workload
              </span>
              <p className="ps-rm-text">
                <strong>Streamlined Assessments:</strong> Automated grading and
                analytics allow more focus on instruction.
              </p>
            </li>

            <li
              style={{ backgroundColor: "#fff6e5" }}
              className="readmore-card-hover ps-rm-list-item"
            >
              <span className="ps-rm-bold-text-highlighted">
                MTSS Integrated
              </span>
              <p className="ps-rm-text">
                <strong>Data Insights:</strong> Predictive analytics identify
                learning gaps early for proactive interventions.
              </p>
            </li>
          </ul>

          <p className="ps-rm-text">
            Our Academics Plateform Core benefits include: Collaboration Boost:
            Real-time sharing among teachers, students, and families fosters
            community. Compliance and Security: FERPA-compliant data handling
            with robust encryption. Cost Savings: Cloud-based models minimize IT
            overhead, with ROI often seen in months through reduced paperwork
            and improved efficiency Scalability: From single classrooms to
            district-wide deployments, it adapts to growth.
          </p>
        </div>

        {/* --- KEY FEATURES --- */}
        <div className="ps-rm-section-card">
          <div className="enrollment-image-card ps-rm-image-wrapper">
            <img
              src="../images/product&soluction/read-more/sisReadmore6.jpg"
              alt="Features"
              className="ps-rm-image"
            />
          </div>
          <h2 className="ps-rm-h2">
            Key Features of Our Academic Management Software
          </h2>
          <p className="ps-rm-text">
            Modern platforms provide a comprehensive suite of tools,
            customizable to fit any K-12 setting. Here's an in-depth look:
          </p>

          <ul className="ps-rm-list">
  <li
    style={{ backgroundColor: "#e9fbf8" }}
    className="readmore-card-hover ps-rm-list-item"
  >
    <span className="ps-rm-bold-text-highlighted">
      Content Creation:
    </span>{" "}
    Drag-and-drop builders for lessons, quizzes, and multimedia. Onsite: Blended
    tools. Online: Asynchronous modules.
  </li>

  <li
    style={{ backgroundColor: "#f3edff" }}
    className="readmore-card-hover ps-rm-list-item"
  >
    <span className="ps-rm-bold-text-highlighted">
      Assessment Tools:
    </span>{" "}
    Formative/summative tests with auto-grading, rubrics, and plagiarism
    detection. Standards-aligned for public prep.
  </li>

  <li
    style={{ backgroundColor: "#fff6e5" }}
    className="readmore-card-hover ps-rm-list-item"
  >
    <span className="ps-rm-bold-text-highlighted">
      Progress Tracking:
    </span>{" "}
    Real-time dashboards showing performance, attendance, and behavior metrics
    with predictive at-risk ID.
  </li>
</ul>


          <ReadMore maxHeight="100px">
            <p className="ps-rm-text">
              Collaboration and Communication: Discussion forums, group
              projects, and video conferencing (e.g., via Zoom integration).
              Online: Virtual breakout rooms. Onsite: Device management for
              in-class tech . Multi-language support for diverse public
              districts. Curriculum Management: Mapping tools to align lessons
              with standards, pacing guides, and scope/sequence. Private
              schools: Customization for specialized programs (e.g., IB or
              Montessori). Public: District-wide consistency. Reporting and
              Analytics: Custom reports for grades, demographics, and growth
              metrics. Export to tools like Google Sheets or integration with
              data warehouses. For all: Compliance reports for state audits
              Integration and Mobility: Seamless SSO with Google Workspace,
              Microsoft 365, or SIS platforms. Mobile apps for iOS/Android,
              ensuring anytime access API extensibility for custom add-ons.
              Administrative Oversight: Teacher performance tracking,
              professional development modules. Budget-friendly for publics;
              advanced analytics for privates
            </p>
          </ReadMore>
        </div>

        {/* --- TAILORING SECTION --- */}
        <div className="ps-rm-section-card">
          <h2 className="ps-rm-h2">
            Tailoring for Online vs. Onsite K-12 Schools
          </h2>
          <div className="ps-rm-adaptation-wrapper">
            <div
              style={{background : "#0984e316"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong>Online Schools:</strong> These demand robust virtual
                capabilities. Software like Canvas or Moodle excels with
                asynchronous content delivery, video hosting, and AI proctoring
                for exams. Public online charters integrate with state virtual
                academies for compliance, while private ones offer global
                collaboration features. Tools track engagement via login
                analytics, ensuring no student falls behind in remote settings.
              </p>
            </div>
            <div
              style={{background: "#6c5ce716"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong>Onsite Schools:</strong> Focus on hybrid integration.
                Platforms like Schoology or Google Classroom support in-class
                tech with screen sharing and device monitoring. Public onsite
                districts use it for large-group instruction and PD, while
                private campuses add enrichment like VR simulations. Features
                like quick polls and group activities enhance face-to-face
                dynamics.
              </p>
            </div>
          </div>
          <h2 className="ps-rm-h2">
            Adaptations for Private vs. Public K-12 Schools
          </h2>
          <div className="ps-rm-adaptation-wrapper">
          <div
              style={{background : "#0984e316"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong>Private Schools:</strong> Emphasize exclusivity and
                customization. Systems like Blackboard Learn or CYPHER provide
                advanced personalization, financial aid-linked access, and
                alumni tracking for long-term engagement. Marketing highlights
                premium features like bespoke curricula and high parent
                involvement, aiding retention and fundraising.
              </p>
            </div>
            <div
              style={{background: "#6c5ce716"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong>Public Schools:</strong> Prioritize accessibility and
                equity. Affordable options like Google Classroom or Edsby handle
                diverse populations with translation tools and free/reduced
                access. Integration with public SIS ensures seamless reporting
                for funding and accountability, supporting inclusive education
                across districts.
              </p>
            </div>
          </div>
        </div>

        <div className="ps-rm-section-card">
          <div style={{ marginTop: "20px" }}>
            <h2 className="ps-rm-h2">Real-World Success and ROI</h2>
            <div className="readmore-card-hover ps-rm-admin-tile">
              <p
                className="ps-rm-text"
              >
                School using our academics management showed 20% improved test
                scores through targeted interventions. Implementation is
                straightforward, with training and migration included.
              </p>
            </div>
          </div>
          {/* --- TRANSFORM CTA --- */}
          <div className="ps-rm-cta">
            <h2 style={{ marginTop: 0 }}>
              Transform Your Academic Ecosystem Today
            </h2>
            <p style={{ fontSize: "1.2rem" }}>
              Don't settle for outdated methods—embrace academic management
              software to inspire learning and streamline operations. Whether
              online or onsite, private or public, platforms like these elevate
              your K-12 school.
            </p>
            <p style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
              Schedule a demo today, and step into a brighter educational
              future. Your students' success starts here!
            </p>
          </div>
        </div>
      </div>

      <div className="section-divider">
      <div className="divider-line"></div>
      <div className="divider-dot"></div>
    </div>


      <div className="ps-rm-wrapper" id="Unlock">
        {/* --- HERO SECTION --- */}
        <div className="ps-rm-section-card">
          <div
            className="readmore-card-hover-border ps-rm-command-header"
          >
            <div
              style={styles.imageContainer}
              className="enrollment-image-card"
            >
              <img
                src="../images/product&soluction/read-more/sisReadmore10.jpg"
                alt="Admin Console"
                className="ps-rm-image"
              />
            </div>
            <h1 className="ps-rm-h1">
              Unlock School-Wide Efficiency with Administrative Console
              Software: Run Operations with Visibility and Controls
            </h1>
            <p className="ps-rm-text">
              In the fast-paced K-12 education landscape, school administrators
              juggle countless responsibilities—from student safety and academic
              oversight to financial management and compliance. Enter Our
              Administrative Console software: a powerful, centralized dashboard
              that delivers school-wide visibility and controls to run
              operations seamlessly.
            </p>
          </div>
          <ReadMore maxHeight="100px">
            <p className="ps-rm-text">
              Whether you're leading a public district with thousands of
              students, a private academy emphasizing personalized experiences,
              a fully online program managing virtual workflows, or a
              traditional onsite campus coordinating daily logistics, this
              software acts as your command center. Our platform integrates
              real-time data, automation, and customizable controls to empower
              admins, reduce silos, and drive institutional success. As K-12
              institutions adapt to hybrid models and increasing regulatory
              demands, Administrative Console software isn't just a tool—it's a
              strategic asset.
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "20px 0",
              }}
            >
              {/* <span style={styles.roiBadge}>40% EFFICIENCY BOOST</span> */}
              <p className="ps-rm-text">
                With the global school management software market projected to
                grow significantly, investing in these systems can boost
                operational efficiency by up to{" "}
                <span style={{ fontWeight: 700 }}> 40%. </span>
              </p>
            </div>
          </ReadMore>
        </div>

        <div className="ps-rm-section-card">
          <div className="enrollment-image-card ps-rm-image-wrapper">
            <img
              src="../images/product&soluction/read-more/sisReadmore8.jpg"
              alt="Operations"
              className="ps-rm-image"
            />
          </div>
          <h2 className="ps-rm-h2">
            Why Administrative Console Software is Essential
          </h2>
          <p className="ps-rm-text">
            Traditional methods—spreadsheets, emails, and fragmented apps—lead
            to errors, delays, and burnout. Administrative Consoles address this
            by offering: Unified Visibility, Granular Controls, Operational
            Streamlining, Data Security and Compliance, Cost and Time Savings,
            and Adaptability.
          </p>
          <div className="ps-rm-comparison-grid">
            <div
              style={{backgroundColor: "#eaf4ff" }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Public Schools:</strong> Simplifies state reporting and
              accountability pressures.
            </div>

            <div
              style={{backgroundColor: "#f3edff" }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Private Schools:</strong> Donor management and tuition
              oversight.
            </div>

            <div
              style={{ backgroundColor: "#e9fbf8" }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Online Programs:</strong> Leverage virtual controls for
              digital workflows.
            </div>

            <div
              style={{backgroundColor: "#fff6e5" }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Onsite Schools:</strong> Handle physical assets like
              facilities and coordination.
            </div>

            {/* ➕ New Card 1 */}
            <div
              style={{ backgroundColor: "#fae1dd" }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Hybrid Institutions:</strong> Manage blended learning
              environments with unified administrative controls.
            </div>

            {/* ➕ New Card 2 */}
            <div
              style={{backgroundColor: "#eae4e9" }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Multi-Campus Groups:</strong> Centralize operations,
              reporting, and governance across multiple locations.
            </div>
          </div>
        </div>

        <div className="ps-rm-section-card">
          <div className="enrollment-image-card ps-rm-image-wrapper">
            <img
              src="../images/product&soluction/read-more/sisReadmore9.jpg"
              alt="Features"
              className="ps-rm-image"
            />
          </div>
          <h2 className="ps-rm-h2">
            Core Features of Our Administrative Console
          </h2>
          <p className="ps-rm-text">
            Our Modern platform packs robust, user-friendly features tailored to
            K-12 needs. Here's a detailed breakdown:
          </p>
          <div className="ps-rm-comparison-grid">
            <div
              style={{
                backgroundColor: "#eaf4ff",
                borderLeftColor: "#2d3436",
              }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Centralized Analytics:</strong> AI-powered insights for
              enrollment trends, staff performance, and predictive issue
              identification.
            </div>

            <div
              style={{
                backgroundColor: "#f3edff",
                borderLeftColor: "#2d3436",
              }}
               className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Operations Management:</strong> Attendance tracking,
              automated financial oversight, and facility maintenance requests.
            </div>

            <div
              style={{
                backgroundColor: "#e9fbf8",
                borderLeftColor: "#2d3436",
              }}
               className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Access & Security:</strong> Role-based permissions,
              multi-factor authentication, and encrypted automated backups.
            </div>

            <div
              style={{
                backgroundColor: "#fff6e5",
                borderLeftColor: "#2d3436",
              }}
               className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Compliance Hub:</strong> One-click generation of CRDC and
              ESSA reports with data warehousing for historical analysis.
            </div>

            {/* ➕ New Card 1 */}
            <div
              style={{
                backgroundColor: "#fae1dd",
                borderLeftColor: "#2d3436",
              }}
               className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Workflow Automation:</strong> Reduce manual tasks with
              automated approvals, notifications, and cross-department handoffs.
            </div>

            {/* ➕ New Card 2 */}
            <div
              style={{
                backgroundColor: "#eae4e9",
                borderLeftColor: "#2d3436",
              }}
              className="readmore-card-hover ps-rm-admin-tile"
            >
              <strong>Scalable Governance:</strong> Adapt policies, permissions,
              and reporting structures as institutions grow or expand campuses.
            </div>
          </div>
        </div>

        <div className="ps-rm-section-card">
          {/* --- SECTION 1: ONLINE VS ONSITE --- */}
          <h2 className="ps-rm-h2">Tailoring for Online vs. Onsite</h2>
          <div className="ps-rm-adaptation-wrapper">
            {/* ONLINE SCHOOLS CARD */}
            <div
              style={{background: "#6c5ce716"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong style={styles.strong("#6c5ce7")}>
                  Online Schools:
                </strong>{" "}
                Require virtual-centric controls. Software offers remote
                dashboards for monitoring digital attendance, content access,
                and cybersecurity. Public online charters integrate with state
                virtual systems, while private virtual academies use analytics
                for personalized learning paths.
              </p>
            </div>

            {/* ONSITE SCHOOLS CARD */}
            <div
              style={{background: "#00d2ff16"}}
             className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
                <strong className="ps-rm-bold-text">
                  Onsite Schools:
                </strong>{" "}
                Physical campuses demand hybrid oversight. Platforms like
                Frontline or Infinite Campus provide controls for in-person
                elements, such as RFID-based attendance, facility maintenance,
                and emergency protocols.
              </p>
            </div>
          </div>

          {/* --- SECTION 2: PRIVATE VS PUBLIC --- */}
          <h2 className="ps-rm-h2">Adaptations for Private vs. Public</h2>
          <div className="ps-rm-adaptation-wrapper">
            {/* PRIVATE SCHOOLS CARD */}
            <div
              style={{background: "#0984e316"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
              <strong className="ps-rm-bold-text">
                  Private Schools:
                </strong>{" "}
                Focus on revenue and relationships. Consoles include donor
                management, variable tuition controls, and alumni tracking.
                Visibility into financial aid supports strategic planning.
              </p>
            </div>

            {/* PUBLIC SCHOOLS CARD */}
            <div
              style={{background: "#00b89416"}}
              className="readmore-card-hover-border ps-rm-adaptation-box"
            >
              <p className="ps-rm-text">
              <strong className="ps-rm-bold-text">
                  Public Schools:
                </strong>{" "}
                Emphasize equity and scale. Systems automate district-wide
                reporting, ELL tracking, and resource allocation. Controls
                ensure fair access and community transparency.
              </p>
            </div>
          </div>

          <div
            className="readmore-card-hover ps-rm-admin-tile"
          >
            <p className="ps-rm-text">
              <strong>Proven Results:</strong> School reports faster growth,
              highlighting ease and support. Implementation includes data
              migration and training, with cloud deployment minimizing IT needs.
            </p>
          </div>

          {/* --- CTA SECTION --- */}
          <div className="ps-rm-footer-banner">
            <h2 className="ps-rm-h1">
              Take Control of Your School's Future Today
            </h2>
            <p className="ps-rm-text">
              Don't let operational chaos hinder your mission. Embrace
              Administrative Console software for unparalleled visibility and
              controls.
            </p>
            <p
              className="ps-rm-text"
            >
              Contact us for a free demo, and transform how you run operations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentInformationSystemReadmore;
